import { render, staticRenderFns } from "./ShowGeneralErrors.vue?vue&type=template&id=4b267051&"
import script from "./ShowGeneralErrors.vue?vue&type=script&lang=js&"
export * from "./ShowGeneralErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports